import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Save", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.saveTask()), ["prevent"]))
  }, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.task.title) = $event)),
      type: "text",
      placeholder: "write a title"
    }, null, 512), [
      [_vModelText, _ctx.task.title]
    ]),
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.task.description) = $event)),
      rows: "3",
      placeholder: "write a description"
    }, null, 512), [
      [_vModelText, _ctx.task.description]
    ]),
    _hoisted_1
  ], 32))
}